export default __webpack_public_path__ + "a4ee2ea284bf104bf88587473d050f7e.png";